<form autocomplete="off" [formGroup]="remainingDataForm" (ngSubmit)="onSubmit()"
  class="d-flex flex-column align-items-center">
  <div class="mb-1 form-item-container reactive-validation"
    [ngClass]="{ valid: isFieldValid('bornDate'), invalid: isFieldInvalid('bornDate') }">
    <label class="col-form-label">*Fecha de Nacimiento</label>
    <div class="w-100">
      <input type="date" class="form-control" placeholder="DD/MM/AAAA" formControlName="bornDate" [readonly]="true"
        (blur)="onFieldBlur('bornDate')" />
    </div>
  </div>

  <div class="mb-1 form-item-container reactive-validation"
    [class.invalid-field]="formUtils.isValidField(remainingDataForm, 'expeditionDate')"
    [ngClass]="{ valid: isFieldValid('expeditionDate'), invalid: isFieldInvalid('expeditionDate') }">
    <label class="col-form-label">*Fecha de expedición de documento</label>
    <div class="w-100">
      <input type="date" class="form-control" placeholder="DD/MM/AAAA" formControlName="expeditionDate"
        (blur)="onFieldBlur('expeditionDate')" />
      @if (formUtils.isValidField(remainingDataForm, 'expeditionDate')) {
      <span class="form-text text-danger">
        {{ remainingDataFormUtils.getErrorMessage(remainingDataForm, 'expeditionDate') }}
      </span>
      }
    </div>
  </div>

  <div class="mb-1 form-item-container reactive-validation"
    [class.invalid-field]="formUtils.isValidField(remainingDataForm, 'country')"
    [ngClass]="{ valid: isFieldValid('country'), invalid: isFieldInvalid('country') }">
    <label class="col-form-label">*País de nacimiento</label>
    <div class="w-100">
      <input type="text" class="form-control" placeholder="Colombia" formControlName="country"
        [ngbTypeahead]="searchCountry" [inputFormatter]="formatter" [resultFormatter]="formatter"
        (blur)="validateSelection('country'); onFieldBlur('country')" />
      @if (formUtils.isValidField(remainingDataForm, 'country')) {
      <span class="form-text text-danger">
        {{ remainingDataFormUtils.getErrorMessage(remainingDataForm, 'country') }}
      </span>
      }
    </div>
  </div>

  <div class="mb-1 form-item-container reactive-validation"
    [class.invalid-field]="formUtils.isValidField(remainingDataForm, 'city')"
    [ngClass]="{ valid: isFieldValid('city'), invalid: isFieldInvalid('city') }">
    <label class="col-form-label">*Ciudad y departamento</label>
    <div class="w-100">
      <input type="text" class="form-control" placeholder="Bogotá" formControlName="city" [ngbTypeahead]="searchCity"
        [inputFormatter]="formatter" [resultFormatter]="formatter"
        (blur)="validateSelection('city'); onFieldBlur('city')" />
      @if (formUtils.isValidField(remainingDataForm, 'city')) {
      <span class="form-text text-danger">
        {{ remainingDataFormUtils.getErrorMessage(remainingDataForm, 'city') }}
      </span>
      }
    </div>
  </div>

  <div class="mb-1 form-item-container reactive-validation"
    [class.invalid-field]="formUtils.isValidField(remainingDataForm, 'address')"
    [ngClass]="{ valid: isFieldValid('address'), invalid: isFieldInvalid('address') }">
    <label class="col-form-label">*Dirección</label>
    <div class="w-100">
      <input type="text" class="form-control" placeholder="Ingresa tu dirección" formControlName="address"
        [value]="formattedAddress" (input)="onAddressInput($event)" (blur)="onFieldBlur('address')" />
      @if (formUtils.isValidField(remainingDataForm, 'address')) {
      <span class="form-text text-danger">
        {{ remainingDataFormUtils.getErrorMessage(remainingDataForm, 'address') }}
      </span>
      }
    </div>
  </div>

  <div class="mb-1 form-item-container reactive-validation"
    [class.invalid-field]="formUtils.isValidField(remainingDataForm, 'number')"
    [ngClass]="{ valid: isFieldValid('number'), invalid: isFieldInvalid('number') }">
    <label class="col-form-label">*Número de celular</label>
    <div class="w-100">
      <input type="text" inputmode="numeric" class="form-control" placeholder="3004263078" formControlName="number"
        (input)="onNumberInput($event, false)" (blur)="onFieldBlur('number')" />
      @if (formUtils.isValidField(remainingDataForm, 'number')) {
      <span class="form-text text-danger">
        {{ remainingDataFormUtils.getErrorMessage(remainingDataForm, 'number') }}
      </span>
      }
    </div>
  </div>

  <div class="mb-1 form-item-container reactive-validation"
    [class.invalid-field]="formUtils.isValidField(remainingDataForm, 'email')"
    [ngClass]="{ valid: isFieldValid('email'), invalid: isFieldInvalid('email') }">
    <label class="col-form-label">*Email</label>
    <div class="w-100">
      <input type="email" class="form-control" placeholder="Ej: usuario@correo.com" formControlName="email"
        (input)="formatEmailField()" (blur)="onFieldBlur('email')" (keydown)="blockUnicode($event)" />
      @if (formUtils.isValidField(remainingDataForm, 'email')) {
      <span class="form-text text-danger">
        {{ remainingDataFormUtils.getErrorMessage(remainingDataForm, 'email') }}
      </span>
      }
    </div>
  </div>

  <div class="row mb-1 mandatory-box">
    <p class="mandatory-fields p-0">*Los campos son obligatorios</p>
  </div>

  <!-- Radio button -->
  <div class="row mb-1 question-container">
    <label class="form-question">¿El dueño pagará el seguro?</label>
    <div class="w-100 d-flex">
      <div class="form-check check-option">
        <input type="radio" formControlName="isPayer" class="form-check-input" value="Y" id="radioSi" />
        <label class="form-check-label check-option" for="radioSi"> Sí </label>
      </div>

      <div class="form-check">
        <input type="radio" formControlName="isPayer" class="form-check-input" value="N" id="radioNo" />
        <label class="form-check-label" for="radioNo"> No </label>
      </div>
    </div>
  </div>

  @if (remainingDataForm.get('isPayer')?.value === 'N') {
  @if(selectedOnerous.isCeroKM){
  <div class="mt-4 mb-1 form-item-container">
    <label class="titleRemainingData">Ingresa los datos del titular del pago</label>
  </div>
  }


  <div class="mb-1 form-item-container reactive-validation"
    [class.invalid-field]="formUtils.isValidField(remainingDataForm, 'payerFirstName')"
    [ngClass]="{ valid: isFieldValid('payerFirstName'), invalid: isFieldInvalid('payerFirstName') }">
    <label class="col-form-label">*Primer nombre</label>
    <div class="w-100">
      <input type="text" class="form-control" placeholder="Ingresa tu nombre" formControlName="payerFirstName"
        (blur)="onFieldBlur('payerFirstName')" />
      @if (formUtils.isValidField(remainingDataForm, 'payerFirstName')) {
      <span class="form-text text-danger">
        {{ remainingDataFormUtils.getErrorMessage(remainingDataForm, 'payerFirstName') }}
      </span>
      }
    </div>
  </div>

  <div class="mb-1 form-item-container reactive-validation"
    [class.invalid-field]="formUtils.isValidField(remainingDataForm, 'payerSecondName')"
    [ngClass]="{ valid: isFieldValid('payerSecondName'), invalid: isFieldInvalid('payerSecondName') }">
    <label class="col-form-label">Segundo Nombre</label>
    <div class="w-100">
      <input type="text" class="form-control" placeholder="Ingresa tu nombre" formControlName="payerSecondName"
        (blur)="onFieldBlur('payerSecondName')" />
      @if (formUtils.isValidField(remainingDataForm, 'payerSecondName')) {
      <span class="form-text text-danger">
        {{ remainingDataFormUtils.getErrorMessage(remainingDataForm, 'payerSecondName') }}
      </span>
      }
    </div>
  </div>

  <div class="mb-1 form-item-container"
    [class.invalid-field]="formUtils.isValidField(remainingDataForm, 'payerFirstLastName')">
    <label class="col-form-label">*Primer Apellido</label>
    <div class="w-100">
      <input type="text" class="form-control" placeholder="Ingresa tu apellido" formControlName="payerFirstLastName" />
      @if (formUtils.isValidField(remainingDataForm, 'payerFirstLastName')) {
      <span class="form-text text-danger">
        {{ remainingDataFormUtils.getErrorMessage(remainingDataForm, 'payerFirstLastName') }}
      </span>
      }
    </div>
  </div>

  <div class="mb-1 form-item-container"
    [class.invalid-field]="formUtils.isValidField(remainingDataForm, 'payerSecondLastName')">
    <label class="col-form-label">Segundo apellido</label>
    <div class="w-100">
      <input type="text" class="form-control" placeholder="Ingresa tu apellido" formControlName="payerSecondLastName" />
      @if (formUtils.isValidField(remainingDataForm, 'payerSecondLastName')) {
      <span class="form-text text-danger">
        {{ remainingDataFormUtils.getErrorMessage(remainingDataForm, 'payerSecondLastName') }}
      </span>
      }
    </div>
  </div>

  <div class="mb-1 form-item-container"
    [class.invalid-field]="formUtils.isValidField(remainingDataForm, 'payerIdentificationType')">
    <label class="col-form-label">*Tipo de identificación</label>
    <div class="w-100">
      <select id="tipoDocumento" class="form-control" formControlName="payerIdentificationType">
        @for (documentType of documentTypes; track documentType) {
        <option [value]="documentType.value">
          {{ documentType.label }}
        </option>
        }
      </select>
      @if (formUtils.isValidField(remainingDataForm, 'payerIdentificationType')) {
      <span class="form-text text-danger">
        {{ remainingDataFormUtils.getErrorMessage(remainingDataForm, 'payerIdentificationType') }}
      </span>
      }
    </div>
  </div>

  <div class="mb-1 form-item-container"
    [class.invalid-field]="formUtils.isValidField(remainingDataForm, 'payerDocument')">
    <label class="col-form-label">*Número de documento</label>
    <div class="w-100">
      <input type="text" class="form-control" placeholder="Digita el número sin puntos"
        formControlName="payerDocument" />
      @if (formUtils.isValidField(remainingDataForm, 'payerDocument')) {
      <span class="form-text text-danger">
        {{ remainingDataFormUtils.getErrorMessage(remainingDataForm, 'payerDocument') }}
      </span>
      }
    </div>
  </div>

  <div class="mb-1 form-item-container"
    [class.invalid-field]="formUtils.isValidField(remainingDataForm, 'payerExpeditionDate')">
    <label class="col-form-label">*Fecha de expedición de documento</label>
    <div class="w-100">
      <input type="date" class="form-control" placeholder="DD/MM/AAAA" formControlName="payerExpeditionDate" />
      @if (formUtils.isValidField(remainingDataForm, 'payerExpeditionDate')) {
      <span class="form-text text-danger">
        {{ remainingDataFormUtils.getErrorMessage(remainingDataForm, 'payerExpeditionDate') }}
      </span>
      }
    </div>
  </div>

  <div class="mb-1 form-item-container"
    [class.invalid-field]="formUtils.isValidField(remainingDataForm, 'payerBornDate')">
    <label class="col-form-label">*Fecha de Nacimiento</label>
    <div class="w-100">
      <input type="date" class="form-control" placeholder="DD/MM/AAAA" formControlName="payerBornDate" />
      @if (formUtils.isValidField(remainingDataForm, 'payerBornDate')) {
      <span class="form-text text-danger">
        {{ remainingDataFormUtils.getErrorMessage(remainingDataForm, 'payerBornDate') }}
      </span>
      }
    </div>
  </div>

  <div class="mb-1 form-item-container"
    [class.invalid-field]="formUtils.isValidField(remainingDataForm, 'payerCountry')">
    <label class="col-form-label">*País de nacimiento</label>
    <div class="w-100">
      <input type="text" class="form-control" placeholder="Colombia" formControlName="payerCountry"
        [ngbTypeahead]="searchCountry" [inputFormatter]="formatter" [resultFormatter]="formatter"
        (blur)="validateSelection('country')" />
      @if (formUtils.isValidField(remainingDataForm, 'payerCountry')) {
      <span class="form-text text-danger">
        {{ remainingDataFormUtils.getErrorMessage(remainingDataForm, 'payerCountry') }}
      </span>
      }
    </div>
  </div>

  <div class="mb-1 form-item-container" [class.invalid-field]="formUtils.isValidField(remainingDataForm, 'payerCity')">
    <label class="col-form-label">*Ciudad y departamento</label>
    <div class="w-100">
      <input type="text" class="form-control" placeholder="Excribe y seleccona una ciudad" formControlName="payerCity"
        [ngbTypeahead]="searchCity" [inputFormatter]="formatter" [resultFormatter]="formatter"
        (blur)="validateSelection('city')" />
      @if (formUtils.isValidField(remainingDataForm, 'payerCity')) {
      <span class="form-text text-danger">
        {{ remainingDataFormUtils.getErrorMessage(remainingDataForm, 'payerCity') }}
      </span>
      }
    </div>
  </div>

  <div class="mb-1 form-item-container"
    [class.invalid-field]="formUtils.isValidField(remainingDataForm, 'payerAddress')">
    <label class="col-form-label">*Dirección de residencia</label>
    <div class="w-100">
      <input type="text" class="form-control" placeholder="Escribe tu dirección" formControlName="payerAddress"
        [value]="formattedAddress" (input)="onAddressInput($event, true)" />
      @if (formUtils.isValidField(remainingDataForm, 'payerAddress')) {
      <span class="form-text text-danger">
        {{ remainingDataFormUtils.getErrorMessage(remainingDataForm, 'payerAddress') }}
      </span>
      }
    </div>
  </div>

  <div class="mb-1 form-item-container"
    [class.invalid-field]="formUtils.isValidField(remainingDataForm, 'payerNumber')">
    <label class="col-form-label">*Número de celular</label>
    <div class="w-100">
      <input type="text" inputmode="numeric" class="form-control" placeholder="3004263078" formControlName="payerNumber"
        (input)="onNumberInput($event, true)" />
      @if (formUtils.isValidField(remainingDataForm, 'payerNumber')) {
      <span class="form-text text-danger">
        {{ remainingDataFormUtils.getErrorMessage(remainingDataForm, 'payerNumber') }}
      </span>
      }
    </div>
  </div>

  <div class="mb-1 form-item-container" [class.invalid-field]="formUtils.isValidField(remainingDataForm, 'payerEmail')">
    <label class="col-form-label">*Correo electrónico</label>
    <div class="w-100">
      <input type="text" class="form-control" placeholder="Ej: usuario@correo.com" formControlName="payerEmail"
        (input)="formatEmailField(true)" (keydown)="blockUnicode($event)" />
      @if (formUtils.isValidField(remainingDataForm, 'payerEmail')) {
      <span class="form-text text-danger">
        {{ remainingDataFormUtils.getErrorMessage(remainingDataForm, 'payerEmail') }}
      </span>
      }
    </div>
  </div>
  }

  <div class="authorization-container">
    <div class="form-check text-start my-3">
      <input class="form-check-input" type="checkbox" id="flexCheckDefault" formControlName="termsAndConditions" />
      <div class="authorization_box">
        <a id="autoriza" class="authorization-text" (click)="openModal()">
          @if (remainingDataForm.get('isPayer')?.value === 'N') {
          Tanto el dueño de vehículo como la persona que pagará el seguro, autorizan a <strong>Suramericana
            S.A.</strong> el tratamiento
          de mis datos para las finalidades contenidas en la <strong>política de privacidad</strong>, donde también se
          encuentran los
          canales de contacto y la forma de ejercer mis derechos
          } @else {
          Autorizo a <strong>Suramericana S.A.</strong> el tratamiento de mis datos para las finalidades contenidas en
          la
          <strong>política de privacidad</strong>, donde también se encuentran los canales de contacto y la forma de
          ejercer mis derechos.
          }
        </a>
      </div>
    </div>
  </div>

  <div class="row mt-3 form-item-container">
    <button class="btn btn-primary form-button" type="submit" [disabled]="remainingDataForm.invalid">Continuar</button>
  </div>
</form>